import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import './SegmAnnoLabelCreate.css';

const SegmAnnoLabelCreate = () => {
  const location = useLocation();
  const [foreignPrefilled, setForeignPrefilled] = useState(false);
  const [formData, setFormData] = useState({
    foreign_key_content_type: '',
    foreign_key_object_id: '',
    file_path: '',
    frame_index: '',
    datasets: '',
    annotator: '',
    cardiac_phase: 'RANDOM',
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const token = localStorage.getItem('token');

  useEffect(() => {
      const searchParams = new URLSearchParams(location.search);
      const dicomId = searchParams.get('dicom_id');
      if (dicomId) {
        setFormData((prev) => ({ ...prev, foreign_key_content_type: "dicom", foreign_key_object_id: dicomId }));
        setForeignPrefilled(true);
      }
    }, [location.search]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const payload = {
      foreign_key: {
        modality: formData.foreign_key_content_type,
        id: parseInt(formData.foreign_key_object_id, 10),
      },
      file_path: formData.file_path,
      frame_index: parseInt(formData.frame_index, 10),
      datasets: formData.datasets
        ? formData.datasets.split(",").map((dataset) => dataset.trim())
        : [],
      annotator: formData.annotator,
      cardiac_phase: formData.cardiac_phase,
    };
  
    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/patients/segm_anno_labels/create/`,
        payload,
        { headers: { Authorization: `Token ${token}` } }
      );
      setSuccess(true);
      setError('');
      setFormData({
        foreign_key_content_type: '',
        foreign_key_object_id: '',
        file_path: '',
        frame_index: '',
        datasets: '',
        annotator: '',
        cardiac_phase: 'RANDOM',
      });
    } catch (err) {
      console.error(err);
      setError('Error creating SegmAnno Label. Check fields or try again.');
      setSuccess(false);
    }
  };
  

  return (
    <div className="segm-anno-label-create-container">
      <h3>Create New SegmAnno Label</h3>
      {error && <p className="error-message">{error}</p>}
      {success && <p className="success-message">SegmAnno Label created successfully!</p>}

      <form onSubmit={handleSubmit} className="segm-anno-label-create-form">
        <div className="form-group">
          <label>Content Type  <span className="required-asterisk">*</span></label>
          <input
            type="text"
            name="foreign_key_content_type"
            value={formData.foreign_key_content_type}
            onChange={handleChange}
            placeholder='Content Type. e.g. "dicom"'
            required
            disabled={foreignPrefilled}
          />
        </div>
        <div className="form-group">
          <label>Object ID  <span className="required-asterisk">*</span></label>
          <input
            type="text"
            name="foreign_key_object_id"
            value={formData.foreign_key_object_id}
            onChange={handleChange}
            placeholder='Object ID. e.g. "1"'
            required
            disabled={foreignPrefilled}
          />
        </div>
        <div className="form-group">
          <label>File Path  <span className="required-asterisk">*</span></label>
          <input
            type="text"
            name="file_path"
            value={formData.file_path}
            onChange={handleChange}
            placeholder="File Path"
            required
          />
        </div>
        <div className="form-group">
          <label>Frame Index  <span className="required-asterisk">*</span></label>
          <input
            type="number"
            name="frame_index"
            value={formData.frame_index}
            onChange={handleChange}
            placeholder="Frame Index (starting from 1)"
            required
            min="1"
          />
        </div>
        <div className="form-group">
          <label>Datasets</label>
          <input
            type="text"
            name="datasets"
            value={formData.datasets}
            onChange={handleChange}
            placeholder="Comma separated. e.g. 'dataset1, dataset2'"
          />
        </div>
        <div className="form-group">
          <label>Annotator <span className="required-asterisk">*</span></label>
          <input
            type="text"
            name="annotator"
            value={formData.annotator}
            onChange={handleChange}
            placeholder="Annotator name"
            required
          />
        </div>
        <div className="form-group">
          <label>Cardiac Phase</label>
          <select
            name="cardiac_phase"
            value={formData.cardiac_phase}
            onChange={handleChange}
          >
            <option value="RANDOM">Random</option>
            <option value="SYSTOLE">Systole</option>
            <option value="DIASTOLE">Diastole</option>
          </select>
        </div>
        
        <button type="submit" className="segm-anno-label-create-btn">
          Create SegmAnno Label
        </button>
      </form>
    </div>
  );
};

export default SegmAnnoLabelCreate;
